<form [formGroup]="formGroupLicenceType">
  <h2>Licence Type</h2>
  <div class="licence-type__container licence-type__container--with-wizard-buttons">
    <div class="licence-type__checkbox__group">
      <h4 class="licence-type__checkbox__title">Select the licence type(s) you intend to apply for using this account:</h4>
      <div class="licence-type__checkbox__row">
        <div class="licence-type__checkbox-column">
          <p>
            <mat-checkbox formControlName="ar" (change)="toggleAircraftRadio($event.checked)">Aircraft Radio</mat-checkbox>
          </p>
          <p><mat-checkbox formControlName="rl">Radio Links</mat-checkbox></p>
          <p><mat-checkbox formControlName="tb">Programme Making and Special Events (PMSE)</mat-checkbox></p>
          <p><mat-checkbox formControlName="sa">Satellite</mat-checkbox></p>
        </div>
        <div class="licence-type__checkbox-column">
          <p><mat-checkbox formControlName="br">Business Radio</mat-checkbox></p>
          <p><mat-checkbox formControlName="wtt">Wireless Test and Trial</mat-checkbox></p>
          <p><mat-checkbox formControlName="er" (change)="toggleClubAccount($event.checked)">Amateur Station</mat-checkbox></p>
          <p><mat-checkbox formControlName="other">Other</mat-checkbox></p>
        </div>
      </div>

      @if (showAircraftNote) {
        <p class="licence-type__note">
          <strong>Please Note;</strong> An Aircraft Station Licensee i.e. the Account Holder, must be the Registered Owner of the aircraft and be a
          legal entity i.e. an individual or a registered company
        </p>
      }
      @if (showClubAccount) {
        <p class="licence-type__note">
          <mat-checkbox formControlName="isClubAccount">Please tick if you wish to create a Club Account</mat-checkbox>
        </p>
      }
      @if (formGroupLicenceType.invalid && (formGroupLicenceType.dirty || formGroupLicenceType.touched)) {
        <span class="licence-type__error-message"> You must select at least one licence type to continue with your account request</span>
      }
    </div>
  </div>
</form>
